import { RouteRecordRaw } from 'vue-router';
import { PatientViewerRoute } from '@/router/routes/viewer/patient-viewer.route';

export const ViewerController: RouteRecordRaw = {
  path: '',
  meta: { requireAuth: true },
  children: [PatientViewerRoute],
};
